import React from "react";
import { Button, CircularProgress } from "@mui/material";

const UnitsSelection = ({ unit, handleClick }) => {
  return (
    <Button
      variant="contained"
      onClick={handleClick}
      sx={{
        minWidth: "100px",
        transition: "all 0.3s linear",
        backgroundColor: (theme) => theme.palette.primary.dark,
        color: (theme) => theme.palette.primary.light,
        "&:hover": {
          backgroundColor: (theme) => theme.palette.primary.light,
          color: (theme) => theme.palette.primary.dark,
        },
      }}
    >
      {unit?.unit?.title || <CircularProgress />}
    </Button>
  );
};

export default UnitsSelection;
